<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30 distributor-page">
    <div class="card bd-gray-400" style="padding-right: 0">
      <draggable
        @update="datadragEnd"
        v-model="itemsDrag"
        :options="{ animation: 300, handle: '.dargDiv' }"
        class="ul"
      >
        <div
          class="li dargDiv"
          v-for="(item, index) in itemsDrag"
          :key="item.id + index"
        >
          <div class="m_fav_album">
            <div class="m_cover m_cover_c pos-relative">
              <div
                class="flag flag-left bg-info"
                :class="{ 'tx-12': item.type == 3 }"
              >
                {{ typeName[item.type] }}
              </div>
              <span class="count"
                >{{ item.imgCnt }} {{ $t("product.张") }}</span
              >
              <div class="img_wrap">
                <a
                  v-if="item.imgUrls && item.imgUrls.length"
                  class="mg-r-5"
                  @click="editProImg(item)"
                  href="javascript:;"
                  v-lazy:background-image="item.imgUrls[0].imgUrl"
                  style="
                    background-size: cover;
                    width: 150px;
                    height: 150px;
                    display: block;
                  "
                >
                </a>
                <a
                  v-else
                  class="mg-r-5"
                  @click="editProImg(item)"
                  href="javascript:;"
                  v-lazy:background-image=""
                  style="
                    background-size: cover;
                    width: 150px;
                    height: 150px;
                    display: block;
                  "
                >
                </a>
              </div>
            </div>
            <div class="detail tx-left mg-t-5">
              <p class="title mg-b-0 tx-ellipsis1">
                <a class="tx-gray-900" href="javascript:;">
                  {{ item.name }}
                </a>
              </p>
              <p class="d-flex justify-content-between mg-b-0 tx-gray-600">
                <span>{{ timeFormat_1(item.timeCreated) }}</span>
                <span>{{ $t($dict.imgsStatus[item.status]) }}</span>
              </p>
              <p class="d-flex justify-content-between mg-b-0">
                <a
                  v-if="isSysRights('SupplierAlbum.changeBySupplier')"
                  href="javascript:;"
                  class="tx-info"
                  @click="editProImg(item)"
                  >{{ $t("product.编辑") }}</a
                >
                <a
                  v-if="isSysRights('SupplierAlbum.deleteBySupplier')"
                  href="javascript:;"
                  class="tx-danger"
                  @click="removeProImg(item)"
                  >{{ $t("product.删除") }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </draggable>
      <div
        v-if="(!items || items.length < 1) && !first_loading"
        class="col-12 none-product"
      >
        <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的数据") }}
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  props: ["first_loading", "items", "typeName"],
  data() {
    return {
      scale: [],
      itemsDrag: [],
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    },
  },
  watch: {
    items: {
      handler: function () {
        this.itemsDrag = this.items;
      },
      deep: true,
    },
  },
  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  components: {
    draggable: draggable,
  },
  methods: {
    datadragEnd(evt) {
      console.log(evt);
      this.$parent.loading = true;
      let newIndex = evt.newIndex;
      let params = {
        id: this.itemsDrag[newIndex].id,
        toId: "",
      };
      if (this.itemsDrag[newIndex + 1]) {
        params.toId = this.itemsDrag[newIndex + 1].id;
      }
      $.api_call("api.SupplierAlbum.moveBySupplier", params, (r) => {
        this.$parent.loading = false;
        if (r.ErrorCode == "9999") {
          this.$parent.getItems();
          ShowTip(this.$t("product.移动成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    timeFormat_1(val) {
      return moment(val, "YYYY-MM-DD H:mm:ss").format("YYYY-MM-DD");
    },
    removeProImg(item) {
      this.$emit("removeProImg", item);
    },
    editProImg(item) {
      this.$router.push({
        path: "/product-img-detail",
        query: { id: item.id },
      });
    },
  },
};
</script>
<style scoped="scoped">
.ul,
.li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.ul:after {
  content: "";
  flex-grow: 99999;
}
.li {
  flex: 1;
  width: 156px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  /*flex:auto;*/
  padding: 0;
  margin-right: 34px;
}
.m_cover .img_wrap {
  position: relative;
  background: url(/img/cover_bg.png) no-repeat 0 0;
  padding: 1px 0 0 1px;
}
.m_cover_c .img_wrap {
  position: relative;
  width: 156px;
  height: 156px;
  background-position: -25px -209px;
}
.m_cover_c .img_wrap img {
  width: 150px;
  height: 150px;
}
.m_fav_pic img,
.m_fav_album img {
  vertical-align: bottom;
}
.m_cover_c {
  overflow: hidden;
}
.flag {
  position: absolute; /*$t('product.绝对定位')*/
  height: 20px;
  line-height: 20px;
  text-align: center;
  width: 74px;
  color: #fff;
  z-index: 1;
}
.flag-left {
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  left: -18px;
  top: 9px;
}
.count {
  position: absolute;
  right: 10px;
  bottom: 10px;
  height: 22px;
  line-height: 22px;
  color: #fff;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  padding: 0 11px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}
</style>